import { FC, HTMLAttributes } from "react";
import { map } from "lodash-es";
import { useTranslation } from "react-i18next";
import { CoinType, Transaction } from "@onmo/graphql/graphql";
import { useStyles } from "./VodabucksStats.styles";
import { StatCard, StatCardLoading } from "../StatCard";
import { Typography } from "../../core/Typography/Typography";
import {
  TypographyVariant,
  TypographyColor,
} from "../../../constants/typography";
import { TransactionHistoryCard } from "../TransactionHistoryCard";
import { groupByDateReward } from "../../../models/rewardHistory";
import { getCurrencyIcon } from "../../../constants/wallet";

interface IVodabucksStatsProps {
  balance?: number;
  vodabucksHistory?: Transaction[];
  loading?: boolean;
}

export const VodabucksStats: FC<
  HTMLAttributes<HTMLDivElement> & IVodabucksStatsProps
> = ({ balance, vodabucksHistory, loading }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const vodabucksIcon = getCurrencyIcon(CoinType.Vodabucks);
  const history = groupByDateReward(vodabucksHistory);

  if (loading)
    return (
      <div className={classes.root}>
        {Array.from(new Array(3)).map((_, idx) => (
          <StatCardLoading key={idx} />
        ))}
      </div>
    );

  return (
    <div className={classes.root}>
      <StatCard
        statName={`${t("common_Total")} Vodabucks`}
        statContent={balance ?? 0}
        icons={vodabucksIcon}
      />
      {Object.keys(history)?.length > 0 && (
        <div className={classes.transactionHistory}>
          <Typography
            variant={TypographyVariant.BodyB5Medium}
            color={TypographyColor.Disable}
          >
            Vodabucks History
          </Typography>
          <div className={classes.content}>
            {map(Object.keys(history), (dateTime) => (
              <div className={classes.htDate} key={dateTime}>
                <Typography variant={TypographyVariant.BodyB5Medium}>
                  {dateTime}
                </Typography>
                {map(history[dateTime], (item) => (
                  <TransactionHistoryCard
                    rewardsHistory={item}
                    coinIcon={vodabucksIcon}
                    className={classes.htCard}
                    key={item?.id}
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
